module.exports = __webpack_public_path__ + "static/media/c25.3d8280b1.png";